import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _isNil from "lodash/isNil";
var _excluded = ["sublibraries"];
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.object.values.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-param-reassign */
import produce from 'immer';
var secondaryAnalysisUpdated = produce(function (draft, action) {
  var _action$payload = action.payload,
    secondaryAnalysisId = _action$payload.secondaryAnalysisId,
    secondaryAnalysis = _action$payload.secondaryAnalysis,
    _action$payload$updat = _action$payload.updatedFiles,
    updatedFiles = _action$payload$updat === void 0 ? [] : _action$payload$updat;
  var sublibraries = secondaryAnalysis.sublibraries,
    secondaryAnalysisRest = _objectWithoutProperties(secondaryAnalysis, _excluded);
  draft.meta.saving = false;
  draft[secondaryAnalysisId] = _objectSpread(_objectSpread({}, draft[secondaryAnalysisId]), secondaryAnalysisRest);
  if (!_isNil(sublibraries)) {
    draft[secondaryAnalysisId].files.sublibraries = sublibraries;
    var validSublibraryIds = new Set(sublibraries.map(function (s) {
      return s.id;
    }));
    Object.values(draft[secondaryAnalysisId].files.data).forEach(function (file) {
      if (file.sublibraryId && !validSublibraryIds.has(file.sublibraryId)) {
        file.sublibraryId = null;
      }
    });
  }
  updatedFiles.forEach(function (_ref) {
    var id = _ref.id,
      type = _ref.type;
    draft[secondaryAnalysisId].files.data[id].type = type;
  });
});
export default secondaryAnalysisUpdated;